import { InjectionToken } from '@angular/core';
// import { environment } from '../../environments/environment';

export interface ApiEndpoints {
  [key: string]: {
    [key: string]: string;
  };
}

// Define the base URL
const BASE_URL = "https://kga-pos-api-dev-eacjcjecg3fyh8ax.centralindia-01.azurewebsites.net/";

export const API_CONFIG: ApiEndpoints = {

  WebAuth: {
    Login: "user/signin",
    updatePassward: "user/update-password",
  },
  Module: {
    getModuleList: "menudetails/get-module-list",
    addModule:"menudetails/add-module",
    updateModule:"menudetails/update-module"
  },
  Department: {
    DepartmentList: "rolemodule/department-list",
  },

  Role: {
    GetAllRole: "rolemodule/get-role-user-count",
    GetRolebyModule: "rolemodule/role-list",
    GetUsersByRoleId: 'rolemodule/get-role-user-roleid',
    GetMenusByRoleId: 'rolemodule/get-all-menu-to-roleid',
    addRole: "rolemodule/add-role",
    editRole: "rolemodule/update-role",
    getRoleCount: "rolemodule/total-role-count",
    deleteRole:"rolemodule/delete-role",
    updateRoleModule:"rolemodule/update-role-module",
    unTagUser:"rolemodule/delete-user-role",
    GetTagUsers:'rolemodule/get-all-user-for-roleid',
    updateTagUsersToRole:'rolemodule/assign-roles-to-user'
  },
  User: {
    userList: "user/get-users-list",
    addUser: "user/add-user",
    deleteUser: "user/delete-user",
    updateUser: "user/update-user-detail",
    GetUserById:"user/get-users-profile",
    updateUserProfile:"user/update-user-profile",
     GetProfileById:"user/profile-image",
     deleteProfile:"user/delete-user-profile"
  },
  
  menu: {
    getMenu: "menudetails/menu-list",
     getMenubyID: "menudetails/menu-by-menuid",
    menuList: "menudetails/get-submenu-child-list",
    addmenuToRole: "menudetails/add-menu-to-role",
    addMenu: "menudetails/add-menu", 
    updateMenu: "menudetails/update-menu-details",
    assignMenuRole:"/menudetails/assign-roles-to-menu"
  },
  master: {
    getCustomerType: "membersdetails/customer-type-list",
    addCustomerType: "membersdetails/add-customer-type",
    updateCustomerType: "membersdetails/update-customer-type-details",

    getCustomersubType: "membersdetails/get-customer-sub-type-by-customertypeid",


    getPOSLocation: "membersdetails/get-poslocation-list",
    addPOSLocation:"membersdetails/add-pos-location",
    editPOSLocation:"membersdetails/update-pos-location-details",
    getPOSCategory: "membersdetails/get-pos-categorys-list",
    addPOSCategory:"membersdetails/add-pos-category",
    editPOSCategory:"membersdetails/update-pos-category",
    getItemMaster: "item/get-items-list",
    getproject: "ProjectCode/get-ProjectCode-list"
  },
  Tournament: {
    getAllTournaments: "tournament/get-all-tournament-master-list",
    getTournamentItems: "tournament/get-items-for-tournament",
    addTournament: "tournament/add-tournament-master",
    addTournamentItem: "tournament/add-tournament-rate-master",
    updateTournament: "tournament/update-tournament-master",
    updateTournamentItem: "tournament/update-tournament-rate-master"
  },
  Promotion: {
    getAllTournaments: "Promotion/get-promotion-master-list",
    getTournamentItems: "",
    getPromotionType: "/Promotion/get-promotion-type-list",
    addTournament: "Promotion/add-promotion-master",
    addTournamentItem: "Promotion/add-promotion-rate-master",
    addPromotionType: "Promotion/add-Promotion-type",
    updateTournament: "promotion/update-promotion-master",
    updateTournamentItem: "promotion/update-promotion-item-rate-master",
    updatePromotionType: "promotion/update-promotion-type"
  },
  Event: {
    getAllTournaments: "event/get-event-master-list",
    getTournamentItems: "event/get-all-event-rate-master-list",
    getEventType: "event/event-type-list",
    addTournament: "event/add-event-master",
    addTournamentItem: "event/add-event-rate-master",
    addEventType: "event/add-event-type",
    updateTournament: "event/update-event-master",
    updateTournamentItem: "event/update-event-rate-master",
    updateEventType: "event/update-event-type",
  },

  // Add other modules...
};

export const API_CONFIG_TOKEN = new InjectionToken<ApiEndpoints>('api.config', {
  providedIn: 'root',
  factory: () => API_CONFIG
});
